import React from 'react';
import ConfirmWithCommentDialog, { ConfirmWithCommentPayload } from './ConfirmWithCommentDialog';
import { HelpBox } from '../help-boxes';

interface EPDDetails {
  title?: string;
  fullIdentificationNumber?: string;
}

type Props = {
  epd: EPDDetails | null | undefined;
  isOpened: boolean;
  onClose(payload: ConfirmWithCommentPayload | null): void;
};

const DeclinePublicationDialog: React.FC<Props> = ({ epd, isOpened, onClose }) => {
  return (
    <ConfirmWithCommentDialog
      header="Decline EPD publication"
      help={
        <HelpBox>
          <span>
            Please describe the reason for declining the publication of the EPD document &nbsp;
            <b>
              {epd?.fullIdentificationNumber} {epd?.title}
            </b>
          </span>
          The EPD Owner will be informed via email about the reason for the declined publication.
        </HelpBox>
      }
      inputLabelText="Decline publication description"
      primaryButtonText="Decline"
      isOpened={isOpened}
      onClose={onClose}
      isCommentRequired
      closable={false}
    />
  );
};

export default DeclinePublicationDialog;
